import React from 'react';
export function StickyBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-ink-line bg-ink/95 backdrop-blur" data-id="element-161" data-mp="2uwc6a155btue">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3 sm:px-8" data-id="element-162" data-mp="12nlinn9vkd7u">
        <p className="font-display text-sm font-bold text-white sm:text-base" data-id="element-163" data-mp="xspejord5zed">
          Tu Brújula Digital™
        </p>
        <a href="#planes" className="inline-flex items-center justify-center rounded-full bg-violeta-500 px-5 py-2.5 font-display text-xs font-bold text-white transition-colors hover:bg-violeta-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violeta-300 sm:text-sm" data-id="element-164" data-mp="nwmeqpjzicul">
          💜 QUIERO EL MEGAPACK
        </a>
      </div>
    </div>;
}